module.exports = __webpack_public_path__ + "static/img/weixuanzhongwenzi.png@2x.5bb195ee.png";